import React, { useState, useEffect } from 'react'; // Make sure to import the CSS
import TicketForm from '../../../Component/Ticket/TicketForm';
import PricingOwnership from '../../../Component/Ticket/PricingOwnership';
import axiosInstance from '../../../../axiosConfig';
import { formatISOToDateTimeString, logFormErrors } from '../../../../utils/utils';


const TicketTabs = () => {
  const [activeTab, setActiveTab] = useState('basic');
  const [loading, setLoading] = useState(false); // Add loading state
  const [currentPage, setCurrentPage] = useState(1); // Add currentPage state
  const [itemsPerPage, setItemsPerPage] = useState(10); // Add itemsPerPage state
  const [destinationList, setDestinationList] = useState([]); // Add destinationList state
  const [metaData, setMetaData] = useState({
    ownershipTypes: [],
  }); // Add metaData state

  useEffect(() => {
    const fetchMetaData = async () => {
      try {
        console.log("Fetching metadata...");
        const response = await axiosInstance.get(
          '/internal-api/v1/client-web/destination-panel/ticket/meta',
        );

        if (response.data && response.data.result) {
          setMetaData(response.data.result);
          console.log("ticketOrigins:", response.data.result.ticketOrigins);
          console.log("ticketAgeGroups:", response.data.result.ticketAgeGroups);
          console.log("paymentMethods:", response.data.result.paymentMethods);
        }
      } catch (error) {
        console.error("Error fetching metadata:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMetaData();
  }, []);

  const [ticketDetails, setFormData] = useState({
    destinationId: '',
    destinationOwnershipId: '',
    sessions: [],
    ticketTypeId: '',
    ticketOriginId: '',
    ticketAgerId: '',
    name: '',
    displayName: '',
    groupCode: '',
    shortDescription: '',
    description: '',
    validFrom: formatISOToDateTimeString(new Date()),
    validTill: formatISOToDateTimeString(new Date(new Date().setFullYear(new Date().getFullYear() + 1))),
    paymentMethods: [],
    registrationValidFrom: formatISOToDateTimeString(new Date()), // Default to today
    registrationValidTill: formatISOToDateTimeString(new Date(new Date().setFullYear(new Date().getFullYear() + 1))), // Default to one year later
    ownershipTypeCode: '',
    eligibilityCriteria: '',
    term: '',
    tagCodes: [],
    qrReleaseFormatCode: '',
    preTicketIds: [],
    isNicRequired: '0',
    isPassportRequired: '0',
    pdfFile: null,
    // Ticket validity nested object to match API structure
    ticketValidity: {
      validFrom: '',
      validTill: '',
      noOfDays: '',
      noOfMonth: '',
      noOfYears: '',
      noOfHours: '',
      noOfMinutes: ''
    },
    // Ownership array to match API structure
    ownership: [{
      id: '',
      share: ''
    }],
    // Ticket pricing array to match API structure
    ticketPricing: [{
      currencyCode: 'LKR',
      isFreeTicket: false,
      basePrice: '',
      taxPercentage: '',
      discount: '',
      finalPrice: '',
      specialPrice: '',
      validFrom: formatISOToDateTimeString(new Date()),
      validTill: formatISOToDateTimeString(new Date())
    }],
    // Ticket images are split into group/package images and variant images.
    baseTicketImages: [],
    ticketImages: []
  });

  console.log('ticket de', ticketDetails)


  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...ticketDetails,
  //     [name]: value
  //   });
  // };

  // Handle ticket pricing array updates
  const handleTicketPricingChange = (index, field, value) => {
    setFormData(prevDetails => {
      const updatedTicketPricing = [...prevDetails.ticketPricing];
      updatedTicketPricing[index] = {
        ...updatedTicketPricing[index],
        [field]: value,
      };
      return {
        ...prevDetails,
        ticketPricing: updatedTicketPricing,
      };
    });
  };

  // Handle ownership array updates
  const handleOwnershipChange = (index, field, value) => {
    setFormData(prevDetails => {
      const updatedOwnership = [...prevDetails.ownership];
      updatedOwnership[index] = {
        ...updatedOwnership[index],
        [field]: value,
      };
      return {
        ...prevDetails,
        ownership: updatedOwnership,
      };
    });
  };

  // Handle ticket images array updates
  const handleTicketImagesChange = (index, field, value) => {
        console.log("Updated ticket images:", value)
    setFormData(prevDetails => {
      const updatedTicketImages = Array.isArray(prevDetails.ticketImages)
        ? [...prevDetails.ticketImages]
        : [];
      updatedTicketImages[index] = {
        ...updatedTicketImages[index],
        [field]: value,
      };
      return {
        ...prevDetails,
        ticketImages: updatedTicketImages,
      };
    });
  };

  // Add new ticket pricing item
  const addTicketPricingItem = () => {
    setFormData(prevDetails => ({
      ...prevDetails,
      ticketPricing: [
        ...prevDetails.ticketPricing,
        {
          currencyCode: 'LKR',
          isFreeTicket: false,
          basePrice: '',
          taxPercentage: '',
          discount: '',
          finalPrice: '',
          specialPrice: '',
          validFrom: formatISOToDateTimeString(new Date()),
          validTill: formatISOToDateTimeString(new Date())
        }
      ]
    }));
  };

  // Remove ticket pricing item
  const removeTicketPricingItem = (index) => {
    setFormData(prevDetails => ({
      ...prevDetails,
      ticketPricing: prevDetails.ticketPricing.filter((_, i) => i !== index)
    }));
  };

  // Add new ownership item
  const addOwnershipItem = () => {
    setFormData(prevDetails => ({
      ...prevDetails,
      ownership: [
        ...prevDetails.ownership,
        {
          id: '',
          share: ''
        }
      ]
    }));
  };

  // Remove ownership item
  const removeOwnershipItem = (index) => {
    setFormData(prevDetails => ({
      ...prevDetails,
      ownership: prevDetails.ownership.filter((_, i) => i !== index)
    }));
  };

  // Add new ticket images item
  const addTicketImagesItem = () => {
    setFormData(prevDetails => ({
      ...prevDetails,
      ticketImages: [
        ...prevDetails.ticketImages,
        {
          mobileImageFile: null,
          imageFile: null,
          displayOrder: '',
          aspDivHeight: '',
          aspDivWidth: '',
          validFrom: formatISOToDateTimeString(new Date()),
          validTill:  formatISOToDateTimeString(new Date())
        }
      ]
    }));
  };

  // Remove ticket images item
  const removeTicketImagesItem = (index) => {
    setFormData(prevDetails => ({
      ...prevDetails,
      ticketImages: prevDetails.ticketImages.filter((_, i) => i !== index)
    }));
  };

  // API Integration - Form submission with FormData
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (activeTab === 'basic') {
      setActiveTab('images');
      return;
    }

    const ownershipEntries = Array.isArray(ticketDetails.ownership) ? ticketDetails.ownership : [];
    const totalShare = ownershipEntries.reduce((sum, entry) => sum + (parseFloat(entry.share) || 0), 0);
    const hasInvalidOwnership = ownershipEntries.some((entry) => !entry.id || entry.share === '' || Number.isNaN(parseFloat(entry.share)));
    if (!ownershipEntries.length || hasInvalidOwnership || Math.abs(totalShare - 100) > 0.01) {
      alert('Ownership shares must total 100% and each owner must be selected.');
      return;
    }

    // ✅ NEW: combinations come from selected origin + ageGroup (not ticketDetails.ticketPricing)
const selectedOrigins = Array.isArray(ticketDetails.ticketOrigins) ? ticketDetails.ticketOrigins : [];
const selectedAgeGroups = Array.isArray(ticketDetails.ticketAgerId) ? ticketDetails.ticketAgerId : [];

const combinations = [];
selectedOrigins.forEach((originId) => {
  selectedAgeGroups.forEach((ageGroupId) => {
    combinations.push({ originId, ageGroupId });
  });
});

if (combinations.length === 0) {
  alert("Please select Ticket Origin and Ticket Age Group.");
  return;
}

// ✅ NEW: Validate session pricing exists (at least basePrice for each variant)
const sessions = Array.isArray(ticketDetails.sessions) ? ticketDetails.sessions : [];
if (!sessions.length) {
  alert("Please add at least one ticket session.");
  return;
}

// If you want strict validation (every session must have pricing for all variants):
for (let s = 0; s < sessions.length; s += 1) {
  const pricingList = Array.isArray(sessions[s].ticketPricing) ? sessions[s].ticketPricing : [];

  // pricingList length should match combinations length (because you build it from combinations)
  if (pricingList.length !== combinations.length) {
    alert(`Session ${s + 1}: pricing variants are not ready. Please re-check Origin/AgeGroup selections.`);
    return;
  }

  const hasAnyBase = pricingList.some((p) => p?.basePrice !== "" && p?.basePrice !== null && p?.basePrice !== undefined);
  if (!hasAnyBase) {
    alert(`Session ${s + 1}: please enter at least one Base Price.`);
    return;
  }
}


    // const pricingEntries = Array.isArray(ticketDetails.ticketPricing) ? ticketDetails.ticketPricing : [];
    // const combinations = pricingEntries
    //   .filter((pricing) => {
    //     const hasIds = pricing?.originId || pricing?.ageGroupId;
    //     const hasPrice = pricing.basePrice !== '' && pricing.basePrice !== null && pricing.basePrice !== undefined;
    //     return hasIds || hasPrice;
    //   })
    //   .map((pricing, index) => ({
    //     originId: pricing.originId || (ticketDetails.ticketOrigins || [])[index],
    //     ageGroupId: pricing.ageGroupId || (ticketDetails.ticketAgerId || [])[index],
    //     pricing
    //   }))
    //   .filter((combo) => combo.originId && combo.ageGroupId);

    // if (combinations.length === 0) {
    //   alert('Please add pricing for at least one ticket combination.');
    //   return;
    // }

    const normalizeDateTime = (value) => {
      if (!value) {
        return '';
      }
      const trimmed = String(value).trim();
      if (!trimmed) {
        return '';
      }
      if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        const date = new Date(`${trimmed}T00:00:00`);
        return Number.isNaN(date.getTime()) ? '' : formatISOToDateTimeString(date);
      }
      if (trimmed.includes('T') || trimmed.endsWith('Z')) {
        const date = new Date(trimmed);
        return Number.isNaN(date.getTime()) ? '' : formatISOToDateTimeString(date);
      }
      if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(trimmed)) {
        return `${trimmed}:00`;
      }
      if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(trimmed)) {
        return trimmed;
      }
      const date = new Date(trimmed);
      return Number.isNaN(date.getTime()) ? '' : formatISOToDateTimeString(date);
    };

    const normalizeTime = (value) => {
      if (!value) {
        return '';
      }
      const trimmed = String(value).trim();
      if (!trimmed) {
        return '';
      }
      if (/^\d{2}:\d{2}:\d{2}$/.test(trimmed)) {
        return trimmed;
      }
      if (/^\d{2}:\d{2}$/.test(trimmed)) {
        return `${trimmed}:00`;
      }
      return trimmed;
    };

    // API Integration - Headers setup
    try {
      const toCamelCase = str => str && str
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .replace(/(?:^|\s+)([a-zA-Z])/g, (match, p1, offset) => offset === 0 ? p1.toLowerCase() : p1.toUpperCase())
        .replace(/\s+/g, '');
      const normalizeNumber = (value, fallback = '') => {
        if (value === null || value === undefined || value === '') {
          return fallback;
        }
        return String(value);
      };
      const mapDiscountMode = (mode) => {
        if (!mode) {
          return '';
        }
        if (mode === 'Amount') {
          return 'CASH';
        }
        if (mode === 'Percentage') {
          return 'PERCENTAGE';
        }
        return mode;
      };

      const resolvedOwnershipTypeCode = ticketDetails.ownershipTypeCode;
      if (!resolvedOwnershipTypeCode) {
        alert('Please select a Ticket Revenue Share Type.');
        return;
      }

      for (let i = 0; i < combinations.length; i += 1) {
        const combo = combinations[i];
        // const pricing = combo.pricing;
        const formdata = new FormData(); 

        formdata.append("destinationId", ticketDetails.destinationId);
        formdata.append("destinationOwnershipId", ticketDetails.destinationOwnershipId);
        formdata.append("ticketTypeId", ticketDetails.ticketTypeId);
        formdata.append("ticketOriginId", combo.originId);
        formdata.append("ticketAgerId", combo.ageGroupId);
        formdata.append("name", ticketDetails.name);
        formdata.append("displayName", ticketDetails?.displayName || '_');
        formdata.append("shortDescription", ticketDetails.shortDescription);
        formdata.append("groupCode", toCamelCase(ticketDetails.name || ''));
        formdata.append("description", ticketDetails.description);
        formdata.append("validFrom", normalizeDateTime(ticketDetails.validFrom));
        formdata.append("validTill", normalizeDateTime(ticketDetails.validTill));

        ticketDetails.paymentMethods.forEach((method, index) => {
          formdata.append(`paymentMethods[${index}]`, method);
        });

        formdata.append("registrationValidFrom", normalizeDateTime(ticketDetails.registrationValidFrom));
        formdata.append("registrationValidTill", normalizeDateTime(ticketDetails.registrationValidTill));
        formdata.append("ownershipTypeCode", resolvedOwnershipTypeCode);

        formdata.append("ticketValidity[validFrom]", normalizeDateTime(ticketDetails.ticketValidity.validFrom));
        formdata.append("ticketValidity[validTill]", normalizeDateTime(ticketDetails.ticketValidity.validTill));
        formdata.append("ticketValidity[noOfDays]", ticketDetails.ticketValidity.noOfDays);
        formdata.append("ticketValidity[noOfMonth]", ticketDetails.ticketValidity.noOfMonth);
        formdata.append("ticketValidity[noOfYears]", ticketDetails.ticketValidity.noOfYears);
        formdata.append("ticketValidity[noOfHours]", ticketDetails.ticketValidity.noOfHours);
        formdata.append("ticketValidity[noOfMinutes]", ticketDetails.ticketValidity.noOfMinutes);

        ownershipEntries.forEach((owner, index) => {
          formdata.append(`ownership[${index}][id]`, owner.id);
          formdata.append(`ownership[${index}][share]`, owner.share);
        });

        formdata.append("eligibilityCriteria", ticketDetails.eligibilityCriteria);
        formdata.append("term", ticketDetails.term);

        ticketDetails.tagCodes.forEach((tag, index) => {
          formdata.append(`tagCodes[${index}]`, tag);
        });

        const appendTicketImage = (image, imageIndex, isGroupImage) => {
          if (!image || (!image.mobileImageFile && !image.imageFile)) {
            return imageIndex;
          }

          formdata.append(`ticketImages[${imageIndex}][isGroupImage]`, String(isGroupImage));
          formdata.append(`ticketImages[${imageIndex}][mobileImageFile]`, image.mobileImageFile || '');
          formdata.append(`ticketImages[${imageIndex}][imageFile]`, image.imageFile || '');
          formdata.append(`ticketImages[${imageIndex}][displayOrder]`, image.displayOrder || '');
          formdata.append(`ticketImages[${imageIndex}][aspDivHeight]`, image.aspDivHeight || '');
          formdata.append(`ticketImages[${imageIndex}][aspDivWidth]`, image.aspDivWidth || '');
          formdata.append(`ticketImages[${imageIndex}][validFrom]`, normalizeDateTime(image.validFrom));
          formdata.append(`ticketImages[${imageIndex}][validTill]`, normalizeDateTime(image.validTill || image.validTo));
          return imageIndex + 1;
        };

        const baseTicketImages = Array.isArray(ticketDetails.baseTicketImages)
          ? ticketDetails.baseTicketImages
          : [];
        const ticketImages = Array.isArray(ticketDetails.ticketImages) ? ticketDetails.ticketImages : [];
        const imageEntry = ticketImages.find((image) =>
          String(image.originId) === String(combo.originId) && String(image.ageGroupId) === String(combo.ageGroupId)
        );
        const variantImages = Array.isArray(imageEntry?.images) ? imageEntry.images : [];
        let ticketImageIndex = 0;

        baseTicketImages.forEach((image) => {
          ticketImageIndex = appendTicketImage(image, ticketImageIndex, 1);
        });

        variantImages.forEach((image) => {
          ticketImageIndex = appendTicketImage(image, ticketImageIndex, 0);
        });

        // const currencyCode = pricing.currencyCode || 'LKR';
        // const basePrice = normalizeNumber(pricing.basePrice);
        // const taxPercentage = normalizeNumber(pricing.taxPercentage, '0');
        // const discount = normalizeNumber(pricing.discount);
        // const discountMode = discount ? mapDiscountMode(pricing.discountMode || 'CASH') : '';
        // let finalPrice = normalizeNumber(pricing.finalPrice);

        // if (!finalPrice) {
        //   const base = parseFloat(basePrice) || 0;
        //   const tax = parseFloat(taxPercentage) || 0;
        //   const disc = parseFloat(discount) || 0;
        //   let computed = base;
        //   if (discount && discountMode === 'PERCENTAGE') {
        //     computed = base - (base * (disc / 100));
        //   } else if (discount) {
        //     computed = base - disc;
        //   }
        //   computed += computed * (tax / 100);
        //   finalPrice = computed ? computed.toFixed(2) : '';
        // }

        // formdata.append(`ticketPricing[0][currencyCode]`, currencyCode);
        // formdata.append(`ticketPricing[0][basePrice]`, basePrice);
        // formdata.append(`ticketPricing[0][taxPercentage]`, taxPercentage);
        // if (discount) {
        //   formdata.append(`ticketPricing[0][discount]`, discount);
        // }
        // if (discount && discountMode) {
        //   formdata.append(`ticketPricing[0][discountMode]`, discountMode);
        // }
        // if (finalPrice) {
        //   formdata.append(`ticketPricing[0][finalPrice]`, finalPrice);
        // }
        // if (pricing.specialPrice) {
        //   formdata.append(`ticketPricing[0][specialPrice]`, pricing.specialPrice);
        // }
        // formdata.append(`ticketPricing[0][validFrom]`, normalizeDateTime(pricing.validFrom));
        // formdata.append(`ticketPricing[0][validTill]`, normalizeDateTime(pricing.validTill));

        ticketDetails.sessions.forEach((session, sIndex) => {
          // ---- session meta ----
          formdata.append(`ticketSession[${sIndex}][displayName]`, session.displayName || "");
          formdata.append(`ticketSession[${sIndex}][day]`, session.day || "");
          formdata.append(
            `ticketSession[${sIndex}][dayStartFrom]`,
            normalizeTime(session.dayStartFrom)
          );
          formdata.append(
            `ticketSession[${sIndex}][dayEndTo]`,
            normalizeTime(session.dayEndTo)
          );
          formdata.append(
            `ticketSession[${sIndex}][validFrom]`,
            normalizeDateTime(session.validFrom)
          );
          formdata.append(
            `ticketSession[${sIndex}][validTill]`,
            normalizeDateTime(session.validTill)
          );

          // ---- pricing INSIDE session (ONLY for this combo) ----
const pricingList = Array.isArray(session.ticketPricing) ? session.ticketPricing : [];

// pick ONLY the price for this combo
// ✅ 1) match by ids (best, if your objects contain originId/ageGroupId)
let price = pricingList.find(
  (p) =>
    String(p.originId) === String(combo.originId) &&
    String(p.ageGroupId) === String(combo.ageGroupId)
);

// ✅ 2) fallback: if your pricingList order == combinations order
if (!price) price = pricingList[i];

// if still missing, backend will fail anyway
if (!price) {
  throw new Error(
    `Missing pricing for originId=${combo.originId}, ageGroupId=${combo.ageGroupId} in session ${sIndex}`
  );
}

// IMPORTANT: always send as [0] (single pricing per session per request)
const pIndex = 0;

formdata.append(
  `ticketSession[${sIndex}][ticketPricing][${pIndex}][currencyCode]`,
  price.currencyCode || "LKR"
);
formdata.append(
  `ticketSession[${sIndex}][ticketPricing][${pIndex}][isFreeTicket]`,
  price.isFreeTicket === true || price.isFreeTicket === 1 || price.isFreeTicket === "1" ? "1" : "0"
);
formdata.append(
  `ticketSession[${sIndex}][ticketPricing][${pIndex}][basePrice]`,
  normalizeNumber(price.basePrice)
);
formdata.append(
  `ticketSession[${sIndex}][ticketPricing][${pIndex}][taxPercentage]`,
  normalizeNumber(price.taxPercentage, "0")
);

if (price.discount) {
  formdata.append(
    `ticketSession[${sIndex}][ticketPricing][${pIndex}][discount]`,
    normalizeNumber(price.discount)
  );
}

// if (price.discountMode) {
//   formdata.append(
//     `ticketSession[${sIndex}][ticketPricing][${pIndex}][discountMode]`,
//     mapDiscountMode(price.discountMode) // Amount->CASH, Percentage->PERCENTAGE
//   );
// }

if (price.finalPrice) {
  formdata.append(
    `ticketSession[${sIndex}][ticketPricing][${pIndex}][finalPrice]`,
    normalizeNumber(price.finalPrice)
  );
}

if (price.specialPrice) {
  formdata.append(
    `ticketSession[${sIndex}][ticketPricing][${pIndex}][specialPrice]`,
    normalizeNumber(price.specialPrice)
  );
}

formdata.append(
  `ticketSession[${sIndex}][ticketPricing][${pIndex}][validFrom]`,
  normalizeDateTime(price.validFrom)
);
formdata.append(
  `ticketSession[${sIndex}][ticketPricing][${pIndex}][validTill]`,
  normalizeDateTime(price.validTill)
);

        }); 


        formdata.append("qrReleaseFormatCode", ticketDetails.qrReleaseFormatCode);

        ticketDetails.preTicketIds.forEach((id, index) => {
          formdata.append(`preTicketIds[${index}]`, id);
        });

        formdata.append("isNicRequired", ticketDetails.isNicRequired);
        formdata.append("isPassportRequired", ticketDetails.isPassportRequired);

        console.log("Submitting ticket combination:", combo);
        for (const [key, value] of formdata.entries()) {
          console.log(`${key}: ${value}`);
        }

        const response = await axiosInstance.post(
          '/internal-api/v1/client-web/destination-panel/ticket/new-ticket',
          formdata
        );
        console.log(
          "Ticket created successfully:",
          response.data,
          `originId=${combo.originId}`,
          `ageGroupId=${combo.ageGroupId}`
        );
      }

      alert("Ticket(s) created successfully.");
      window.location.reload();
    } catch (error) {
      console.error("Error submitting form:", error);
      logFormErrors(error, null); // Pass null for toast if not using it

    }
  };


  const tabs = [
    { id: 'basic', label: 'Basic Info' },
    { id: 'images', label: 'Ownership and Images' },
  ];

  return (
    <div className="bg-white border rounded-xl border-slate-200">
      <div className="px-6 pt-6">
        <h1 className="text-xl font-bold text-slate-900">Add New Tickets</h1>

        {/* Tabs */}
        <div className="flex mt-4 border-b border-slate-200">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`px-4 py-3 mr-2 text-sm font-semibold border-b-2 -mb-px transition-colors ${
                activeTab === tab.id
                  ? 'text-brand-blue border-brand-blue'
                  : 'text-slate-500 border-transparent hover:text-slate-700'
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Basic Info Tab Content */}
      {activeTab === 'basic' && (
        <div className="p-6">
          < TicketForm setTicketDetails={setFormData} ticketDetails={ticketDetails} handleSubmit={handleSubmit} />
        </div>
      )}

      {/* Location Tab */}
      {activeTab === 'images' && (
        <div className="p-6">
          <PricingOwnership 
            setTicketDetails={setFormData} 
            ticketDetails={ticketDetails} 
            handleSubmit={handleSubmit}
            handleTicketPricingChange={handleTicketPricingChange}
            handleOwnershipChange={handleOwnershipChange}
            handleTicketImagesChange={handleTicketImagesChange}
            addTicketPricingItem={addTicketPricingItem}
            removeTicketPricingItem={removeTicketPricingItem}
            addOwnershipItem={addOwnershipItem}
            removeOwnershipItem={removeOwnershipItem}
            addTicketImagesItem={addTicketImagesItem}
            removeTicketImagesItem={removeTicketImagesItem}
          />
        </div>
      )}

    </div>
  );
};

export default TicketTabs;
